import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import {
  coriolisLogoWhiteWide,
  coriolisLogoDark,
  evoLogoWhite,
  evoLogoBlack,
} from 'images';

const PREFIX = 'Logo';
const EVO_DOMAIN = 'app.evoesg.com';

const classes = {
  root: `${PREFIX}-root`,
  reactBadge: `${PREFIX}-reactBadge`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    width: '100%',
    paddingLeft: 10,

    '& .logo-icon': {
      transition: theme.transitions.create(['width', 'height'], {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut
      })
    },
    '& .normal': {
      height: 24
    },
    '& .large': {
      height: 45
    },
    '& .react-badge, & .logo-text': {
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut
      })
    }
  },

  [`& .${classes.reactBadge}`]: {
    backgroundColor: '#121212',
    color: '#61DAFB'
  }
}));

interface Props {
  name?: 'coriolis';
  color?: string;
  alt?: string;
  height?: number;
  className?: string;
}


function Logo(props: Props): JSX.Element {
  const { hostname } = window.location; // no way to use location hook, because some usages out of router
  const { color, height, alt = 'logo', className = '' } = props;

  let imgSrc = color === 'white' ? coriolisLogoWhiteWide : coriolisLogoDark;

  if (hostname === EVO_DOMAIN) {
    imgSrc = color === 'white' ? evoLogoWhite : evoLogoBlack;
  }

  return (
    <Root className={clsx(classes.root, 'flex items-center')}>
      <img
        className={clsx({
          'logo-icon': !className.length,
          [className]: className.length
        })}
        style={{height : height || 24}}
        src={imgSrc}
        alt={alt} />
    </Root>
  );
}

export default Logo;

